import { render, staticRenderFns } from "./home-default.vue?vue&type=template&id=2d324016&scoped=true&"
import script from "./home-default.vue?vue&type=script&lang=ts&"
export * from "./home-default.vue?vue&type=script&lang=ts&"
import style0 from "./home-default.vue?vue&type=style&index=0&id=2d324016&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d324016",
  null
  
)

export default component.exports